import { createStore } from 'vuex';
export default createStore({
  state: {
    primeRecommendations: {},
    watchlist: {},
    researchReports: {},
    notificationCentre: null,
    allNotificationsRead: false,
    userProfile: {},
    myPortfolio: {
      "ownPortfolio": {}
    },
    portfolioType: 'own',
    subscriptionType: 'subscriber',
    niftyVMI: {},
    holdingType: 'all', 
  },
  mutations: {
    SET_PRIME_RECOMMENDATIONS(state, recommendations) {
      state.primeRecommendations = recommendations;
    },
    SET_WATCHLIST(state, watchlist) {
      state.watchlist = watchlist;
    },
    SET_RESEARCH_REPORTS(state, reports) {
      state.researchReports = reports;
    },
    SET_NOTIFICATION(state, notification) {
      state.notificationCentre = notification;
    },
    SET_USERPROFILE(state, userProfile) {
      state.userProfile = userProfile;
    },
    SET_MYPORTFOLIO(state, myPortfolio) {
      state.myPortfolio = myPortfolio;
    },
    SETPORTFOLIOTYPE(state, portfolioType) {
      state.portfolioType = portfolioType;
    },

    SETHOLDINGTYPE(state, holdingType) {
      state.holdingType = holdingType;
    },

    SETSUBSCRIPTIONTYPE(state, subscriptionType) {
      state.subscriptionType = subscriptionType;
    },
    SET_NIFTYVMI(state, niftyVMI) {
      state.niftyVMI = niftyVMI;
    },
    SET_NOTIFICATION_STATUS(state, { status }) {
      if (Array.isArray(state.notificationCentre)) {
        state.notificationCentre.forEach(notification => {
          notification.status = status;
        });
      }
      state.allNotificationsRead = status === 'read';
    },
    SET_ALL_NOTIFICATIONS_READ(state, isRead) {
      state.allNotificationsRead = isRead;
    },
    UPDATE_SINGLE_NOTIFICATION_STATUS(state, { notificationId, status }) {
      if (state.notificationCentre) {
        const notification = state.notificationCentre.find(n => n.notification_id === notificationId);
        if (notification) {
          notification.status = status ? 'read' : 'unread';
        }
      }
    }
  },
  actions: {
    async fetchData({ commit }) {
      try {
        const baseURL = process.env.VUE_APP_BASE_URL;
        const action = 'api_dashboard_new';
        const response = await fetch(`${baseURL}/wp-admin/admin-ajax.php?action=${action}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        commit('SET_PRIME_RECOMMENDATIONS', data.recommendations);
        commit('SET_WATCHLIST', data.watchlist);
        commit('SET_RESEARCH_REPORTS', data.researchReports);
        commit('SET_NOTIFICATION', data.notificationCentre);
        commit('SET_USERPROFILE', data.userProfile);
        if ((data.userProfile.prime_status == 'Trial Expired') || (data.userProfile.prime_status == 'Subscription expired')) {
          commit('SETSUBSCRIPTIONTYPE', 'sub-expired');
        }  
        commit('SET_MYPORTFOLIO', data.myPortfolio);
        commit('SET_NIFTYVMI', data.niftyVMI);
        return data;
      } catch (error) {
        console.error('Error fetching data from API, falling back to local data:', error);
        try {
          const response = await fetch('/data/demo.json');
          if (!response.ok) {
            throw new Error('Network response was not ok for local data');
          }
          const data = await response.json();
          commit('SET_PRIME_RECOMMENDATIONS', data.recommendations);
          commit('SET_WATCHLIST', data.watchlist);
          commit('SET_RESEARCH_REPORTS', data.researchReports);
          commit('SET_NOTIFICATION', data.notificationCentre);
          commit('SET_USERPROFILE', data.userProfile);
          if ((data.userProfile.prime_status == 'Trial Expired') || (data.userProfile.prime_status == 'Subscription expired')) {
            commit('SETSUBSCRIPTIONTYPE', 'sub-expired');
          }
          else if (data.userProfile.prime_status == 'Trial User') {
            commit('SETSUBSCRIPTIONTYPE', 'Trial');
          }
          commit('SET_MYPORTFOLIO', data.myPortfolio);
          commit('SET_NIFTYVMI', data.niftyVMI);
          return data;
        } catch (localError) {
          console.error('Error fetching data from local JSON file:', localError);
          throw localError;
        } 
      }
    },
    async updateNotificationStatus({ commit }) {
      try {
        const baseURL = process.env.VUE_APP_BASE_URL;
        const response = await fetch(`${baseURL}/wp-admin/admin-ajax.php?action=dashboard_notification_status`, {
          method: 'POST'
        });
        const data = await response.json();
        if (data.success) {
          commit('SET_NOTIFICATION_STATUS', 'read');
          return true;
        } else {
          commit('SET_ALL_NOTIFICATIONS_READ', false);
          return false;
        }
      } catch (error) {
        console.error('Failed to update notification status:', error);
        commit('SET_ALL_NOTIFICATIONS_READ', false);
        return false;
      }
    },
    async markNotificationAsRead({ commit }, notificationId) {
      try {
        const baseURL = process.env.VUE_APP_BASE_URL;
        const response = await fetch(`${baseURL}/wp-admin/admin-ajax.php?action=mark_notification_status&notification_id=${notificationId}`, {
          method: 'POST'
        });  
        const data = await response.json();
        if (data.success) {
          commit('UPDATE_SINGLE_NOTIFICATION_STATUS', { notificationId, status: true });
          return true;
        } else {
          commit('UPDATE_SINGLE_NOTIFICATION_STATUS', { notificationId, status: false });
          return false;
        }
      } catch (error) {
        console.error('Failed to mark notification as read:', error);
        return false;
      }
    }
  },
  getters: {
    primeRecommendations: (state) => state.primeRecommendations,
    watchlist: (state) => state.watchlist,
    researchReports: (state) => state.researchReports,
    notificationCentre: (state) => state.notificationCentre,
    userProfile: (state) => state.userProfile,
    planType: (state) => state.userProfile.prime_status,
    isPortfolioEmpty: (state) => {
      const portfolio = state.myPortfolio;
      if (portfolio == null) return true;
      if (Array.isArray(portfolio)) return portfolio.length === 0;
      if (typeof portfolio !== 'object') return true;
      if (Object.keys(portfolio).length === 0) return true;

      const sectionHasData = (section) => {
        if (section == null) return false;
        if (Array.isArray(section)) return section.length > 0;
        if (typeof section !== 'object') return false;

        if (Array.isArray(section.graphSection) && section.graphSection.length > 0) {
          return true;
        }
        if (parseFloat(section.totalCurrentValue || 0) > 0) return true;
        if (parseFloat(section.stockPortfolio?.totalStockValue || 0) > 0) return true;

        return Object.keys(section).some((key) => {
          const value = section[key];
          if (value == null || value === '' || value === '0' || value === '0.0') return false;
          if (Array.isArray(value)) return value.length > 0;
          if (typeof value === 'object') return sectionHasData(value);
          return true;
        });
      };

      return !sectionHasData(portfolio.ownPortfolio) && !sectionHasData(portfolio.familyPortfolio);
    },
    myPortfolio: (state) => state.myPortfolio,
    portfolioType: (state) => state.portfolioType,
    holdingType: (state) => state.holdingType,
    subscriptionType: (state) => state.subscriptionType,
    niftyVMI: (state) => state.niftyVMI,
    allNotificationsRead: (state) => state.allNotificationsRead
  }
});